// edgeFunctionUrl — Q-012: single-point URL-bygge för Supabase edge-
// functions. Tidigare hårdkodade 5 call-sites mönstret
// `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/<name>`. När
// function-routing ändras (t.ex. custom-domain eller path-prefix) krävs
// fem parallella edits. Denna helper centraliserar det.
//
// Pure: läser env vid varje call istället för att cachea, så tests som
// muterar import.meta.env inte behöver en module-reset.

export function buildEdgeUrl(
  functionName: string,
  overrides: { supabaseUrl?: string } = {},
): string {
  const supabaseUrl =
    overrides.supabaseUrl
    ?? (typeof import.meta !== 'undefined' ? import.meta.env?.VITE_SUPABASE_URL : '')
    ?? '';
  const base = String(supabaseUrl || '').replace(/\/+$/, '');
  return `${base}/functions/v1/${functionName}`;
}
